import React, { useState, useEffect } from 'react'

import { parse as parseQuery } from 'query-string'

import { useTranslation, Trans } from 'react-i18next'
import { Alert } from '@material-ui/lab'
import { styled } from '@material-ui/core/styles'

import sessionStorageWrapper from 'src/util/sessionStorageWrapper'
import isBrowser from 'src/util/isBrowser'
import { useStore } from 'store'
import Form from './pageComponents/FormComponent'
import SidebarSection from './pageComponents/SidebarSection'
import SignupStepsContainer from './pageComponents/SignupStepsContainer'

import { Grid, Typography, Box } from '@material-ui/core'

import { apiUrl } from 'src/config'
import { Link, Layout, Section, WaitForAuth } from 'components'

const StyledBox = styled(Box)(({ theme }) => ({}))

const FormHeader = ({ heading, subheading, description, ...props }) => (
  <StyledBox {...props}>
    <Typography variant="h5" component="h2">
      <Trans i18nKey="titles:contactDetails.form.description" />
    </Typography>
    <Typography variant="h4" component="h1">
      <Trans i18nKey="titles:contactDetails.form.title" />
    </Typography>
    {/* <Typography variant="subtitle1">
      Meld je aan om je Airbnb-servicekosten terug te vorderen
    </Typography> */}
  </StyledBox>
)

const Sidebar = () => {
  const { t } = useTranslation()

  return t('formSidebar:contactDetails').map((entry) => (
    <SidebarSection title={entry.title}>
      {entry.body.map((description) => (
        <Typography variant="body2" paragraph>
          {description}
        </Typography>
      ))}
    </SidebarSection>
  ))
}

const AirbnbForm = () => {
  const { t } = useTranslation()
  const [{ referralCode, promoCode, referralCodeValid, auth }] = useStore()
  const [isShared, setIsShared] = useState(false)
  const [anonymousId, setAnonymousId] = useState(false)

  const urlNoQuery = isBrowser() ? window.location.href.split('?')[0] : ''
  useEffect(() => {
    if (isBrowser()) {
      const { share } = parseQuery(window.location.search)
      setIsShared(!!share)
    }
  }, [])

  useEffect(() => {
    const sendPing = async () => {
      const headers = {
        'Content-Type': 'application/json',
      }
      if (auth.isAuthenticated && auth.user) {
        const token = await auth.user.getIdToken()
        headers.authorization = `Bearer ${token}`
      }
      const payload = { book: __BUILDFOR__ }
      const response = await fetch(`${apiUrl}/ping/openedForm`, {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'include', // so cookies are send
        referrerPolicy: 'no-referrer-when-downgrade',
        headers,
      }).then((r) => r.json())

      if (response.result.anonymousId) {
        setAnonymousId(response.result.anonymousId)
      }
    }
    if (auth.loaded) {
      sendPing()
    }
  }, [auth.isAuthenticated, auth.user, auth.loaded])

  const isInvalidReferral = !referralCodeValid
  return (
    <Layout
      title={t('titles:contactDetails.page.title')}
      description={t('titles:contactDetails.page.description')}
    >
      <WaitForAuth>
        <Section>
          <Grid container spacing={3} justify="center">
            <Grid item sm={12} md={7}>
              <SignupStepsContainer>
                <FormHeader />
                {(promoCode ||
                  referralCode ||
                  isShared ||
                  isInvalidReferral) && (
                  <Box mb={4}>
                    {/* <Box my={1}>
                      <Alert severity="info">
                        Op 9 maart 2020 heeft de Rechtbank Amsterdam bepaald dat
                        een huurder die een onderkomen via Airbnb heeft gehuurd
                        de servicekosten mocht terugvorderen die hij heeft
                        betaald. Heb je de afgelopen vijf jaar een boeking
                        gedaan via Airbnb? Dan kan je deze servicekosten
                        terugvorderen. Meer informatie vind je{' '}
                        <Link to="airbnb" target="_blank">
                          hier
                        </Link>
                        .
                      </Alert>
                    </Box> */}

                    {referralCode && (
                      <Box my={1}>
                        <Alert severity="success">
                          Je meldt je aan via een vriend. Dit betekent dat de
                          vriend die jou deze link heeft gestuurd een beloning
                          krijgt als jouw claim succesvol is! Wil je dit niet,
                          klik dan{' '}
                          <Link
                            onClick={() => {
                              sessionStorageWrapper.removeItem('referralCode')
                              if (window) {
                                window.location.href = urlNoQuery
                              }
                            }}
                          >
                            hier
                          </Link>{' '}
                          om je aan te melden zonder referral.
                        </Alert>
                      </Box>
                    )}

                    {isInvalidReferral && (
                      <Box my={1}>
                        <Alert severity="info">
                          Deze vriendenlink is verlopen.
                        </Alert>
                      </Box>
                    )}

                    {promoCode && (
                      <Box my={1}>
                        <Alert severity="success">
                          {t(`airbnbPromo:${promoCode}Body`)}
                        </Alert>
                      </Box>
                    )}
                  </Box>
                )}

                <Form anonymousId={anonymousId} />
              </SignupStepsContainer>
            </Grid>
            <Grid item sm={12} md={3}>
              <Sidebar promoCode={promoCode} />
            </Grid>
          </Grid>
        </Section>
      </WaitForAuth>
    </Layout>
  )
}

export default AirbnbForm
